import { AutoComplete } from 'antd'
import { useExternalLinkEditorContext } from './ExternalLinkEditorContext'
import { AutoCompleteProps } from 'antd/lib/auto-complete'

/**
 * @private
 */
const ExternalLinkEditorAutoComplete: React.FC<
  /**
   * have to expose onChange and value for the form item to work
   */
  Pick<AutoCompleteProps, 'onChange' | 'value'>
> = (props) => {
  const { disabled, quickLinkOptions: quickLinks } =
    useExternalLinkEditorContext()
  return (
    <AutoComplete
      {...props}
      filterOption={(entered, value) =>
        (value?.value as string).toLowerCase().includes(entered.toLowerCase())
      }
      autoClearSearchValue={false}
      disabled={disabled || quickLinks?.loading}
      options={(quickLinks?.quickLinks ?? []).map(({ label }) => ({
        value: label,
        label,
      }))}
      allowClear
    />
  )
}

export default ExternalLinkEditorAutoComplete
